import { classNames } from '@boschebike/ebds-js';
import React, { useId, useRef, useState } from 'react';
const Chip = ({
  ref = null,
  isEnabled = false,
  onClick = () => {},
  text = ''
}) => {
  const componentId = useId();
  const componentRef = useRef(ref);
  const [enabled, setEnabled] = useState(isEnabled);
  const mainClassUuid = `ebds-chip-${componentId}`;
  const mainClass = classNames('ebds-chip', {
    '--enabled': enabled
  });
  return /*#__PURE__*/React.createElement("button", {
    id: mainClassUuid,
    ref: componentRef,
    className: mainClass,
    type: "button",
    "aria-pressed": enabled,
    onClick: () => {
      setEnabled(!enabled);
      onClick();
    }
  }, text);
};
export default Chip;